import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5368b114&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5368b114')) {
      api.createRecord('5368b114', component.options)
    } else {
      api.reload('5368b114', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5368b114&", function () {
      api.rerender('5368b114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/index.vue"
export default component.exports